export const SELECT_EDUCATION_IDS = {
  LEVELS: 'select_education-levels',
  LEVEL: 'select_education-level',
} as const;
